import { useScrolled } from "@/src/hooks/useScrolled";
import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./(sections)/navigation/Navbar";
import { MobileMenu } from "./(sections)/navigation/MobileMenu";
import { CartDrawer } from "./(sections)/cart/CartDrawer";
import { Footer } from "./(sections)/footer/Footer";
import { useCartContext } from "@/src/context/CartContext";

export function MainLayout() {
    const scrolled = useScrolled();
    const { pathname } = useLocation();
    const NO_HERO_ROUTES = [
        "/contact",
        "/candle-care",
        "/privacy-policy",
        "/terms-of-service",
        "/checkout",
        "/order-confirmation",
    ];

    const isTransparent =
        !NO_HERO_ROUTES.includes(pathname) &&
        !pathname.startsWith("/product/") &&
        !pathname.startsWith("/journal/") &&
        !scrolled;
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const {
        cart,
        isCartOpen,
        setIsCartOpen,
        removeFromCart,
        updateQuantity,
        cartTotal,
        cartCount,
    } = useCartContext();

    return (
        <div className="min-h-screen font-sans selection:bg-stone-200">
            <Navbar
                transparent={isTransparent}
                cartCount={cartCount}
                onMenuOpen={() => setIsMenuOpen(true)}
                onCartOpen={() => setIsCartOpen(true)}
            />
            <MobileMenu
                isOpen={isMenuOpen}
                onClose={() => setIsMenuOpen(false)}
            />
            <CartDrawer
                isOpen={isCartOpen}
                cart={cart}
                cartTotal={cartTotal}
                onClose={() => setIsCartOpen(false)}
                onRemove={removeFromCart}
                onUpdateQuantity={updateQuantity}
            />
            <Outlet />
            <Footer />
        </div>
    );
}
